import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I Got Boned by Taxes Two Years in a Row",
  "description": "",
  "published": "2017-05-04T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-got-boned-by-taxes-two-years-in-a-row/swizec/7582"],
  "categories": "Business, Freelancing, Learning, Side Projects",
  "hero": "./img/qv2zHuH.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When I bitch and moan about taxes, everyone always asks, `}<em parentName="p">{`"How the fuck did this happen? What the hell did you do!?"`}</em></p>
    <p>{`So here's a short story about how I became a real American: Someone whose debt is gonna take a few years to pay off. 28 months by current count.`}</p>
    <p><img parentName="p" {...{
        "src": "/84df238d7ffd339fcecd88936052e891/media-116a8zosxwA0SI-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`I know, I know. `}<em parentName="p">{`Real`}</em>{` debt is for 30 years. Bear with me. This is uncharted territory. I don't usually spend money I don't have.`}</p>
    <p>{`Well, okay, sometimes I cover a budgeting mishap with a credit card or a painful withdrawal from the savings account I keep for patching holes in cashflow. But who doesn't?`}</p>
    <p>{`——`}</p>
    <p>{`The story begins in April 2016. A friend hooked me up with a wonderful `}{`[`}{`read: expensive] CPA who was willing to take on my complicated case.`}</p>
    <p>{`I spent the first 4 months of 2015 in Slovenia, then 8 months in San Francisco. Throughout the year, I worked through my Slovenian company: a sole proprietorship taxed in Slovenia at an effective rate of about 10%.`}</p>
    <p>{`The way it works is that for revenue under $100k, some 80% is considered "expenses" and you are taxed on the rest as your personal income. You fall into a tax bracket and pay taxes, mandatory health insurance, and mandatory pension contributions.`}</p>
    <p>{`Americans would call it socialism. At least the mandatory health care and pension part.`}</p>
    <p>{`Okay, so that's the Slovenian taxes. Mandatory monthly payments or Bad Things happen. All fine and well.`}</p>
    <p>{`Where it gets tricky, as my CPA explained in April 2016, is that because my company is a sole proprietorship, and because I'm the sole employee, the USA considers the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Nexus#Law"
      }}>{`nexus`}</a>{` to be wherever I am physically located. So even though I'm paying Slovenian taxes, I have to pay US income taxes on my total revenue when I'm in San Francisco.`}</p>
    <p>{`Great…`}</p>
    <p>{`There is, however, a bilateral agreement that says Slovenia and USA credit each other's income taxes. My CPA was nice enough to read through the entire agreement and figure that out. It's not information either government advertises very loudly.`}</p>
    <p>{`Here's the rub: USA says Slovenia should credit my taxes paid to the USA. I was physically in San Francisco, so those taxes belong to them. Slovenia says USA should credit my taxes paid to Slovenia. My company is registered in Slovenia, so those taxes belong to them.`}</p>
    <p><img parentName="p" {...{
        "src": "/1d4b54d5d6194bd666dca1fa8a637d8c/media-3o7abJASZCpGc64MHm-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Then my CPA discovered even more great news. Turns out I had spent 2 or 3 days over the 6-month limit in San Francisco back in 2014. So I was a US tax resident in 2014 too.`}</p>
    <p>{`Lovely.`}</p>
    <p>{`Oh and Mr. Swizec, you haven't been paying your Obamacare. You have to pay that, too.`}</p>
    <p>{`Wait, what's Obamacare?`}</p>
    <p>{`The national health something, of course. Everyone has to pay that.`}</p>
    <p>{`But I didn't use it! I didn't even know I `}<em parentName="p">{`could`}</em>{` use it! I have health insurance in Slovenia, damn it.`}</p>
    <p>{`Yeah? Tough. Gotta pay. Oh, and there's no bilateral agreement between Slovenia and USA for health care.`}</p>
    <p>{`Wonderful.`}</p>
    <p>{`Damage for 2014 and 2015 taxes: You owe $2,775 to California, and $14,071 to the federal government.`}</p>
    <p>{`Bye bye, all the fuck you money I took so long to save up. Poof! Just like that.`}</p>
    <p><img parentName="p" {...{
        "src": "/ccb31e409a1d72e0cb84b02c8d7e833d/media-xTiTneNyD0KwfoQoYo-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`At least I had the money, right? My reserves were used up, but you can always make more money. Better to be kinda broke than have the ire of IRS on your back.`}</p>
    <p>{`You do not fuck with the taxman. Al Capone went to jail for that shit. Not for killing people, not for bootlegging, not for organized crime. For tax evasion.`}</p>
    <p>{`Let that sink in.`}</p>
    <p>{`Lesson learned, right? Swizec paid a bunch of taxes in April 2016, learned his lesson, and the story ends there.`}</p>
    <p>{`Swizec, it turns out, does not learn lessons. He's kinda dumb like that.`}</p>
    <h2 {...{
      "id": "come-april-2017"
    }}>{`Come April 2017`}</h2>
    <p><em parentName="p">{`"Hello Mr. Swizec, it is time once again to do your tax return. You've been ignoring our offers to help you with quarterly returns. Prepare your butthole.”`}</em></p>
    <p><em parentName="p">{`gulp`}</em></p>
    <p>{`A-ha, but I am ready this time, Mr. Taxman! I've been racking up expenses on my sidehustle, I know that I can claim the home office part of my rent as an expense, I've paid freelancers and bought equipment and all the things. Come at me, bro!`}</p>
    <p><img parentName="p" {...{
        "src": "/5aff0cddce830330b23c4f40d9a3fe9a/media-Lk9SktDAGzYUU-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`I was overconfident.`}</p>
    <p>{`I had spent the entire year in San Francisco. I still had my Slovenian company until January 2017. All year. This did not bode well.`}</p>
    <p>{`You see, I became properly employed in USA after I got some bureaucracy things in order. I felt it prudent to keep Slovenian stuff going until that happened. Wouldn't wanna be caught completely without health insurance in case something happens, ya know?`}</p>
    <p>{`In June 2016, I filed a piece of paper with the Slovenian government saying that I have moved out of the country, and I wanted to stop paying taxes, pretty please. In November 2016, they sent me an email: `}<em parentName="p">{`"Yo, wtf? Do you got some papers to prove this shit?"`}</em></p>
    <p>{`I replied to the email with some PDFs.`}</p>
    <p>{`In December 2016, I got a piece of paper at my old address in Slovenia. It said `}<em parentName="p">{`"Fuck it, you're out. We retroactively grant you status of not paying taxes since August 2016"`}</em>{`.`}</p>
    <p>{`But what about all the deductions I had to keep paying until December?`}</p>
    <p>{`You'll get them back with your tax return in April 2017. Maybe.`}</p>
    <p>{`Joke's on them: A few months after June 2016, I got frustrated with my USA salary being deducted `}<em parentName="p">{`and`}</em>{` having to wire money to Slovenia to pay for Slovenian taxes and health care and pension. So I stopped. It's all going away soon anyway, might as well not pay, right?`}</p>
    <p>{`Nope.`}</p>
    <p>{`In January 2017, my Slovenian accountant was like `}<em parentName="p">{`"Yo dude, you haven't been paying that shit. You should pay that shit.”`}</em></p>
    <p>{`But…`}</p>
    <p>{`No buts. Pay.`}</p>
    <p>{`Wait, but I'm not a tax resident anymore. Why am I paying health care?`}</p>
    <p>{`You still have a company in Slovenia. Even if you're not paying taxes, you have to pay the mandatory health care and pension contributions.`}</p>
    <p>{`Wait, what? I'm not even using that company anymore!`}</p>
    <p>{`Tough. It exists. Gotta pay.`}</p>
    <p>{`So I closed the company, wired some $5000 to Slovenia, and paid what I owed. About $2000 of that was for taxes past the retroactive August 2016 date when I stopped being a tax resident.`}</p>
    <p>{`In April 2017, Slovenia sent me $200 of the taxes I had overpaid. What happened to the rest, I don't know. Guess they looked at my revenue and decided that I was not overpaying.`}</p>
    <p>{`Now comes the fun part.`}</p>
    <p>{`The American IRS is unfazed by any of this. I was here all year, I'm a tax resident, gotta pay for all my global income `}<em parentName="p">{`and`}</em>{` report the highest value of my foreign assets in 2016.`}</p>
    <p>{`Wait, but I used those $18,000 in my Slovenian savings account to pay USA taxes in 2016. I don't wanna say my foreign accounts had that much money and pay taxes on it…`}</p>
    <p>{`Tough. Gotta pay.`}</p>
    <p>{`-`}{`.-`}</p>
    <p>{`I ended up with a convoluted 3-part tax return my CPA pulled out of his hat: One for while I was employed. One for the time I was a contractor. One for my sidehustle.`}</p>
    <p>{`The final damage was $3,824 owed to California, $20,822 owed to the federal government. Some of that is for 6 months of Obamacare before I got real insurance, I think.`}</p>
    <p>{`Now this is the sort of money I don't have. There's $13,000 in my Wealthfront investment account… a few thousand laying around in various PayPal and savings accounts. But it's not enough.`}</p>
    <p>{`Even if I liquidated everything, it's still not enough to get the taxman monkey off my back.`}</p>
    <p>{`I also don't want all my accounts to be at $0. That's not a good place to be. Especially not when your sidehustle has freelancers who expect to be paid on time.`}</p>
    <p><img parentName="p" {...{
        "src": "/ceeb8e5109c13d1944767b7ca03845f3/media-LAFShX32UwUj6-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`My CPA suggested I pay off California in full. It's not a huge amount, and it gives me one less authority to deal with. Took the money out of my sidehustle's PayPal account and paid off California.`}</p>
    <p>{`One down, one to go.`}</p>
    <p>{`The IRS offers something called a payment plan. You can go on their website and say `}<em parentName="p">{`"Look, guys, I'm broke. Can we come to some sort of agreement?"`}</em></p>
    <p>{`They offer several options. You can pay in full within 3 months. Within 6 months. Or opt for a however-long-it-takes monthly payment plan.`}</p>
    <p>{`You are warned, however, there's 5% interest per year on the money you owe. You don't want to pay more than you owe, do you!?`}</p>
    <p>{`5% of $20,822 is $1041. Like I give a shit. I spend 3x that on rent, bills, and groceries every month 😂`}</p>
    <p>{`So I used their helpful calculator. You put in how much you make, how much you think you spend, and they tell you how much you can afford to pay.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3920719f7968b830565d67aaf78e9c5b/1e093/qv2zHuH.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "20.62780269058296%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'83\\'%20viewBox=\\'0%200%20400%2083\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M36%208v5l1-1%202-1%201%201%202%201%202-2h1v3l1%201%202-3c1-2%201-2%201%200v2l1-2%201-1%201%202%201-2h1c1%202%206%202%207%200h1l2%202c2%200%203-1%203-2-1-3-1-3-5-2H50a435%20435%200%2000-14-1m32%2031c0%202%201%203%204%203h7l5-1c2%201%203%200%203-1%200-2%200-2%201%200%201%203%2013%203%2013%200s0-3-12-3c-11%200-13%201-12%202h-3c-1%202-4%202-4%201l1-1v-1c-1-1-1-1%201-1%201-1%201-1-1-1-3%200-3%200-3%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3920719f7968b830565d67aaf78e9c5b/ca0a1/qv2zHuH.webp 223w", "/static/3920719f7968b830565d67aaf78e9c5b/75680/qv2zHuH.webp 445w", "/static/3920719f7968b830565d67aaf78e9c5b/8d1ba/qv2zHuH.webp 890w", "/static/3920719f7968b830565d67aaf78e9c5b/3838e/qv2zHuH.webp 1335w", "/static/3920719f7968b830565d67aaf78e9c5b/8aa17/qv2zHuH.webp 1376w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3920719f7968b830565d67aaf78e9c5b/e92b6/qv2zHuH.png 223w", "/static/3920719f7968b830565d67aaf78e9c5b/e66bf/qv2zHuH.png 445w", "/static/3920719f7968b830565d67aaf78e9c5b/4ef49/qv2zHuH.png 890w", "/static/3920719f7968b830565d67aaf78e9c5b/4e814/qv2zHuH.png 1335w", "/static/3920719f7968b830565d67aaf78e9c5b/1e093/qv2zHuH.png 1376w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/3920719f7968b830565d67aaf78e9c5b/4ef49/qv2zHuH.png",
              "alt": "qv2zHuH",
              "title": "qv2zHuH",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Lol, I'm not paying you $2,000 per month, dear IRS. You crazy? I still gotta put money in savings.`}</p>
    <p>{`I am certain beyond a grain of doubt that my money is better off in my savings and investment accounts than it is in your grubby little paws.`}</p>
    <p>{`Besides, Wealthfront has been giving me a steady 13% return, and your interest is just 5%. Where do `}<em parentName="p">{`you`}</em>{` think I should put that money, eh?`}</p>
    <p>{`So I committed to paying the IRS $800/month in back taxes. I can manage that, I think. Including interest, it's gonna take me until September 2019 to pay this off. 😅`}</p>
    <p>{`Next year, taxes will be easier. I hope. No more double taxing. No more double health care. Deducting all year. That should help. 🤘🏼`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      